__turbopack_context__.v({
  "blue": "EDeoIq_blue",
  "brightness-100": "EDeoIq_brightness-100",
  "brightness-25": "EDeoIq_brightness-25",
  "brightness-50": "EDeoIq_brightness-50",
  "brightness-75": "EDeoIq_brightness-75",
  "flicker-100": "EDeoIq_flicker-100",
  "flicker-25": "EDeoIq_flicker-25",
  "flicker-50": "EDeoIq_flicker-50",
  "flicker-75": "EDeoIq_flicker-75",
  "green": "EDeoIq_green",
  "light": "EDeoIq_light",
  "red": "EDeoIq_red",
  "yellow": "EDeoIq_yellow",
});
